import forEach from 'lodash/forEach';
import sortBy from 'lodash/sortBy';


let storeutilis = {

	isCacheValid(statetime){
		let cachetime = new Date();
			cachetime.setDate(cachetime.getHours() - 4);

		return statetime > cachetime.getTime();
	},

	orderCharts(charts){
		const self = this;
		let out = [];

		forEach(charts, (chart, key) => {
			let outchart = {
				id: chart.id,
				position: chart.position
			};

			if(chart.charts) outchart.charts = self.orderCharts(chart.charts);

			out.push(outchart);
		});

		return sortBy(out, ['position']);
	},

	findChart(charts, id, getWithParent){
		const self = this;
		let out = false;

		forEach(charts, (chart, key) => {
			if(out) return;

			if(chart.id == id) {
				chart._index = key;
				out = chart;
				return;
			}

			if(chart.charts){
				let childout = self.findChart(chart.charts, id, getWithParent);

				if(childout) {
					if(getWithParent) {
						childout.parent = chart;
					}
					childout._index = key;
					out = childout;
					return;
				}
			}
		});
		return out;
	},
	getUsereditFieldById(fields, name){
		const self = this;
		let out = false;
		forEach(fields, (field, key) => {
			if(out) {
				return;
			}

			if(field.name == name) {
				out = field;
				return;
			}

			if(field.fields){
				let childout = self.getUsereditFieldById(field.fields, name);
				if(childout) {
					out = childout;
					return out;
				}
			}
		});

		return out;
	}
};


export default storeutilis;



// WEBPACK FOOTER //
// ./src/helpers/storeutilis.js